/**
 * Do not edit directly
 * Generated on Tue, 07 Feb 2023 13:10:43 GMT
 */

export default "PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yLjUgNi41SDEuNVYxLjVINi41VjIuNUgzLjJMNi40IDUuNkw1LjYgNi40TDIuNSAzLjJWNi41Wk0xMy41IDEyLjhWOS41SDE0LjVWMTQuNUg5LjVWMTMuNUgxMi44TDkuNyAxMC40TDEwLjQgOS42TDEzLjUgMTIuOFpNOS42IDUuNkwxMC40IDYuNEwxMy41IDMuMlY2LjVIMTQuNVYxLjVIOS41VjIuNUgxMi44TDkuNiA1LjZaTTUuNiA5LjZMNi4zIDEwLjRMMy4yIDEzLjVINi41VjE0LjVIMS41VjkuNUgyLjVWMTIuOEw1LjYgOS42WiIgZmlsbD0iaW5oZXJpdCIvPg==";